import Element from './Element';

export default class Group extends Element {

  static displayName = 'Group';

  static defaultProps = {
    component: 'g',
  }

}



// WEBPACK FOOTER //
// packages/element/src/Group.js